import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Toggle from 'components/ReusableComponents/Toggle/index'
import Box from 'features/Hotel/Box'
import { useEffect, useState } from 'react'
import hotelApi from 'services/api/hotel'

import styles from './Hotel.module.scss'

const HotelPreferences = ({
  updateHotelDetails,
  hotelDetails,
  updateLoyaltyOutreach
}) => {
  const {
    isChatBotEnabled,
    isJustAutomatedOtaCampaigns,
    usesSavibookBe,
    isJustAutomatedNonMembers,
    loyaltyPrograms
  } = hotelDetails

  const [parentChainCodes, setParentChainCodes] = useState([])
  const [isLoadingLoyalties, setIsLoadingLoyalties] = useState(false)
  const [selectedLoyaltyPrograms, setSelectedLoyaltyPrograms] = useState(
    loyaltyPrograms || []
  )
  const [isNonMembersSelected, setIsNonMembersSelected] = useState(
    isJustAutomatedNonMembers
  )

  useEffect(() => {
    setIsLoadingLoyalties(true)
    hotelApi
      .getHotelLoyalPrograms()
      .then(data => {
        setParentChainCodes(data.parentChainCodes)
      })
      .catch(() => {
        setParentChainCodes([])
      })
      .finally(() => {
        setIsLoadingLoyalties(false)
      })
  }, [])

  const handleNonMembersToggle = e => {
    const checked = e.target.checked
    setIsNonMembersSelected(checked)
    if (!checked) {
      setSelectedLoyaltyPrograms([])
      updateLoyaltyOutreach({
        isJustAutomatedNonMembers: false,
        programs: []
      })
    }
  }

  const handleSaveChanges = () => {
    updateLoyaltyOutreach({
      isJustAutomatedNonMembers: isNonMembersSelected,
      programs: selectedLoyaltyPrograms
    })
  }

  return (
    <>
      <Box title="Preferences">
        <div className={styles.preferencesWrapper}>
          <div>
            <Toggle
              handleChange={e =>
                updateHotelDetails({ isChatBotEnabled: e.target.checked })
              }
              checked={isChatBotEnabled}
              label="Use chatbot"
            />
          </div>
          <div>
            <Toggle
              handleChange={e =>
                updateHotelDetails({ IsJustAutomatedOtaCampaigns: e.target.checked })
              }
              checked={isJustAutomatedOtaCampaigns}
              label="Only sends OTA campaigns"
            />
          </div>
          <div>
            <Toggle
              handleChange={e => updateHotelDetails({ usesSavibookBe: e.target.checked })}
              checked={usesSavibookBe}
              label="Use Savibook BE"
            />
          </div>
        </div>
      </Box>

      <Box title="Loyalty program outreach">
        <div className={styles.preferencesWrapper}>
          <div>
            <Toggle
              handleChange={e => handleNonMembersToggle(e)}
              checked={isNonMembersSelected}
              label="Only sends to non-members"
            />
          </div>

          {isNonMembersSelected &&
            (isLoadingLoyalties ? (
              <LoadingIndicator inline={true} />
            ) : (
              <div className={styles.parentChainGroup}>
                <p className={styles.membersTitle}>Send to members of</p>
                {parentChainCodes.length > 0 &&
                  parentChainCodes.map(parentChain => (
                    <div key={parentChain.parentChainCode}>
                      <p className={styles.parentChainCodeTitle}>
                        {parentChain.parentChainCode} brand
                      </p>
                      {parentChain.programCounts.map(program => (
                        <div
                          className={styles.innerToggleContainer}
                          key={program.loyaltyProgram}
                        >
                          <Toggle
                            handleChange={e => {
                              const checked = e.target.checked
                              setSelectedLoyaltyPrograms(prev =>
                                checked
                                  ? [...prev, program.loyaltyProgram]
                                  : prev.filter(p => p !== program.loyaltyProgram)
                              )
                            }}
                            checked={selectedLoyaltyPrograms.includes(
                              program.loyaltyProgram
                            )}
                            label={program.loyaltyProgram}
                          />
                        </div>
                      ))}
                    </div>
                  ))}

                <button className={styles.saveButton} onClick={handleSaveChanges}>
                  Save changes
                </button>
              </div>
            ))}
        </div>
      </Box>
    </>
  )
}

export default HotelPreferences
